<template>
  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>

      <el-form-item label="分享海报" prop="share_poster">
        <el-switch v-model="form.share_poster"></el-switch>
      </el-form-item>

      <el-form-item label="微信邀请" prop="wechat_invite">
        <el-switch v-model="form.wechat_invite"></el-switch>
      </el-form-item>

      <el-form-item label="邀请链接" prop="invite_link">
        <el-switch v-model="form.invite_link"></el-switch>
      </el-form-item>

      <!-- 新增摇一摇开关和金额 -->
      <el-form-item label="摇一摇" prop="shake">
        <el-switch v-model="form.shake"></el-switch>
        <el-input-number
          v-if="form.shake"
          v-model="form.shake_amount"
          :min="0"
          :max="10000"
          :precision="2"
          size="small"
          controls-position="right"
          placeholder="输入金额"
          style="margin-left: 10px; width: 150px;"
        ></el-input-number>
      </el-form-item>

      <!-- 新增红包雨开关和金额 -->
      <el-form-item label="红包雨" prop="redpacket_rain">
        <el-switch v-model="form.redpacket_rain"></el-switch>
        <el-input-number
          v-if="form.redpacket_rain"
          v-model="form.redpacket_rain_amount"
          :min="0"
          :max="10000"
          :precision="2"
          size="small"
          controls-position="right"
          placeholder="输入金额"
          style="margin-left: 10px; width: 150px;"
        ></el-input-number>
      </el-form-item>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
        :disabled="loading"
        >保存</el-button
      >
    </div>

    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
  </div>
</template>
<script>
import GtaskApi from "@/api/gtask.js";
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        status: false,
        share_poster: false,
        wechat_invite: false,
        invite_link: false,
        // 新增字段
        shake: false, // 摇一摇开关
        shake_amount: 0, // 摇一摇金额
        redpacket_rain: false, // 红包雨开关
        redpacket_rain_amount: 0 // 红包雨金额
      },
      setting: [],
      loading: false,
      isProductUpload: false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      GtaskApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data);
          if (data.data.vars.values != "[]") {
            self.form = data.data.vars.values;
          }
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      GtaskApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: "恭喜你，保存成功",
              type: "success"
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/gtask/setting/getSetting.vue